import { Box, BoxList } from '@factorialco/deprecated-design-system'
import clouds from 'assets/images/import-clouds.svg'
import { AtsJobApplicationFilesSectionFragment } from 'generated/resources/graphql'

import { Authorized } from 'modules/core/components/Authorized'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { acceptedContentTypes } from 'modules/core/lib/fileFormats'
import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'

import { FileListSkeleton } from 'modules/ats/components/FileListSkeleton'
import { useCandidateFiles } from 'modules/ats/hooks/candidateFiles'
import DropzoneBox from 'modules/documents/components/Documents/DropzoneBox'

import { ApplicationFileItem } from './ApplicationFileItem'

interface Props {
  application: AtsJobApplicationFilesSectionFragment
}

export const ApplicationFiles = ({ application }: Props) => {
  const { loadingFiles, candidateFiles, bulkCreateCandidateFiles } = useCandidateFiles({
    atsCandidateId: application.candidate.id,
  })
  const {
    access: { id: accessId },
    company: { subscription },
  } = useCurrentSession()
  const currentApplicationFiles = candidateFiles.filter(
    (file) => file.atsApplicationId === application.id
  )

  const onUploadFile = async (selectedFiles: File[]) => {
    await bulkCreateCandidateFiles({
      atsCandidateId: application.candidate.id,
      atsApplicationId: application.id,
      resourceId: application.id,
      resourceType: 'application',
      authorId: accessId,
      authorType: 'access',
      files: selectedFiles.map((file) => {
        return { attachment: file }
      }),
    })
  }

  const hasFiles = currentApplicationFiles.length > 0

  return (
    <Box gap="s24" width="full">
      {loadingFiles ? (
        <FileListSkeleton />
      ) : (
        <>
          {hasFeature('ats_upload_files') && hasFiles && (
            <Authorized subscription={subscription}>
              <DropzoneBox
                onDrop={onUploadFile}
                message={i18n.t('documents.drop_here')}
                accept={acceptedContentTypes()}
              />
            </Authorized>
          )}

          {hasFiles ? (
            <BoxList>
              {currentApplicationFiles.map((file) => (
                <ApplicationFileItem key={file.id} applicationFile={file} />
              ))}
            </BoxList>
          ) : (
            hasFeature('ats_upload_files') && (
              <Authorized subscription={subscription}>
                <DropzoneBox
                  onDrop={onUploadFile}
                  icon={clouds}
                  message={i18n.t('documents.drop_here')}
                  accept={acceptedContentTypes()}
                />
              </Authorized>
            )
          )}
        </>
      )}
    </Box>
  )
}
